import styled from 'styled-components';
import { LineProps } from './Line';

export const Line = styled.div<LineProps>`
  border-bottom: ${({ theme, height = 'auto' }) =>
    `${height === 'auto' ? '0.125rem' : '0.1rem'} solid ${theme.color.gray[200]}`};
  height: 0;
  margin: ${({ gap }) => gap && `${gap}rem 0 ${gap}rem 0`};
`;
